const Footer = () => {
    return (
        <footer className="footer mt-auto py-3 bg-dark">
            <div className="container">
                <p className="text-light">App desenvolvido por <a href="https://www.linkedin.com/in/luis-paulo-souza-a54358134?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BWbuA0Q5TTzWoBrjS66PrHQ%3D%3D" target="_blank" rel="noreferrer">Luis Paulo</a></p>
                <p className="text-light"><small><strong>Semana Spring React</strong><br />
      Evento promovido pela escola DevSuperior: <a href="https://instagram.com/devsuperior.ig" target="_blank" rel="noreferrer">@devsuperior.ig</a></small></p>
            </div>
        </footer>
    );
}
export default Footer;